import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { ListItemText, MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'

import RangeSlider from './RangeSlider'
import RangeTextField from './RangeTextField'

export default function FilterRange({
  minBound,
  maxBound,
  min,
  max,
  handleRangeChange,
  step = 1,
  minDistance = 0,
  readOnly = false,
  allLabel,
  usePadding = false,
}) {
  const { t } = useTranslation()

  allLabel = allLabel || t('common.form.all')

  const [localValue, setLocalValue] = useState(allLabel)

  useEffect(() => {
    setLocalValue(min === minBound && max === maxBound ? allLabel : [min, max])
  }, [min, max, minBound, maxBound, allLabel])

  return (
    <Select
      size="small"
      value={localValue}
      disabled={readOnly}
      renderValue={
        (selected) =>
          Array.isArray(selected) ? selected.join(' - ') : selected
        // Array.isArray(selected) ? selected.map((sel) => `${sel}`.padStart(3, '0')).join(' - ') : selected
      }
      MenuProps={{
        disableAutoFocusItem: true,
        MenuListProps: {
          disableListWrap: true,
        },
      }}
      sx={{ width: 1 }}
    >
      <RangeSlider
        minBound={minBound}
        maxBound={maxBound}
        min={min}
        max={max}
        handleRangeChange={handleRangeChange}
        step={step}
        minDistance={minDistance}
        readOnly={readOnly}
        usePadding={usePadding}
      />

      <RangeTextField
        minBound={minBound}
        maxBound={maxBound}
        min={min}
        max={max}
        handleRangeChange={handleRangeChange}
        step={step}
        minDistance={minDistance}
        readOnly={readOnly}
        sx={{ pt: 1 }}
        usePadding={usePadding}
      />
      <MenuItem key={''} value={localValue} sx={{ display: 'none' }}>
        <ListItemText primary={''} />
      </MenuItem>
    </Select>
  )
}

FilterRange.propTypes = {
  minBound: T.number.isRequired,
  maxBound: T.number.isRequired,
  min: T.number.isRequired,
  max: T.number.isRequired,
  handleRangeChange: T.func.isRequired,
  step: T.number,
  minDistance: T.number,
  readOnly: T.bool,
  allLabel: T.string,
  usePadding: T.bool,
}
